import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import React, { useEffect, useState, useRef } from "react";
import { Col, Image, Modal, Row } from "react-bootstrap";
import { BsChevronDown } from "react-icons/bs";
import { CgShoppingCart } from "react-icons/cg";
import { FiMoreHorizontal, FiMoreVertical } from "react-icons/fi";
import { RiDeleteBinLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import actfilter from "../../assets/icons/Pluswhite.svg";
import plusBorderWhite from "../../assets/icons/Plus-border-white.svg";
import Package from "../../assets/icons/package.svg";
import Setting from "../../assets/icons/tool.svg";
import addPart from "../../assets/icons/addPart.png";
import ProductIcon from "../../assets/icons/Product.svg";
import Downarrow from "../../assets/icons/downarrow.svg";
import packageIcn from "../../assets/icons/package_icn.svg";
import searchIcon from "../../assets/icons/search.svg";
import importIcon from "../../assets/icons/shared.svg";
import Pagination from "../../components/Pagination/Pagination";
import Header from "../../layouts/Header";
import {
  DeleteProduct,
  EmptyProductPart,
  FetchProduct,
  FetchProductFilterList,
  fetchTranslationData,
} from "../../redux/actions/action";
import "../../assets/styles/local/ProductsList.css";
import useScreenSize from "../../utils/hooks/useScreenSizeHook";
import xIcon from "../../assets/icons/x-circle.svg";
import smaliIcon from "..//../assets/icons/meh.svg";
import ColorTag from "./ColorTag";
import ProFilter from "./ProFilter";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import MakePurchaseTooltip from "../../components/Common/MakePurchaseTooltip";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import { axiosInstance } from "../../redux/constants/axiosInstance";
import { API_URL } from "../../redux/constants/type";
import {
  showImportJobStatusNotification,
  showProductCatalogueImportNotification,
} from "../../utils/helpers/productCatalogueImportNotification";
import {
  getImportStatusSnapshot,
  getNextPollingDelay,
  hasMeaningfulImportStatusChange,
  isAllImportJobsTerminal,
} from "../../utils/helpers/importStatusPolling";
import Loader from "../../components/Dailogs/Loader";

const MoreActionMenu = ({
  anchorEl,
  open,
  handleClose,
  showModal,
  reciveDataToAddPurchasing,
}) => {
  const history = useHistory();

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Products And Services").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  return (
    <Menu
      id="basic-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      MenuListProps={{
        "aria-labelledby": "basic-button",
      }}
      sx={{
        "& .MuiMenu-paper": {
          borderRadius: "1px",
          background: "#f8f9fa 0% 0% no-repeat padding-box;",
          height: "116px",
          width: "234px",
        },
        "& .MuiMenu-root": {},
        "& .MuiPaper-root": {
          padding: 0,
        },
      }}
    >
      <MenuList>
        <MenuItem
          disableRipple
          enuItem
          sx={{ "&:hover": { background: "transparent", cursor: "default" } }}
        >
          <ListItemText
            sx={{
              "& .MuiTypography-root": {
                position: "absolute !important",
                top: "-18px !important",
                right: "20px !important",
                paddingTop: "10px !important",
              },
            }}
          >
            <FiMoreHorizontal
              color="323232"
              fontSize="1.4rem"
              onClick={handleClose}
              cursor="pointer"
            />
          </ListItemText>
        </MenuItem>

        <MenuItem
          enuItem
          sx={{ width: "234px", paddingTop: "15px" }}
          onClick={() => {
            // history.push("/add-purchasing-order");
            history.push(
              reciveDataToAddPurchasing?.pathname,
              reciveDataToAddPurchasing?.state,
            );
          }}
        >
          <ListItemIcon>
            <CgShoppingCart fontSize="1.4rem" color="#323232" />
          </ListItemIcon>
          <ListItemText
            sx={{
              "& .MuiTypography-root": {
                fontSize: "14px !important",
                color: "#323232 !important",
                fontWeight: "500 !important",
              },
            }}
          >
            {/* Purchase */}
            {t("Purchase")}
          </ListItemText>
        </MenuItem>

        <MenuItem
          enuItem
          sx={{ width: "234px" }}
          onClick={(e) => {
            e.preventDefault();
            showModal(true);
            handleClose();
          }}
        >
          <ListItemIcon>
            <RiDeleteBinLine fontSize="1.4rem" color="#323232" />
          </ListItemIcon>
          <ListItemText
            sx={{
              "& .MuiTypography-root": {
                fontSize: "14px !important",
                color: "#323232 !important",
                fontWeight: "500 !important",
              },
            }}
          >
            {/* Delete */}
            {t("Delete")}
          </ListItemText>
        </MenuItem>
      </MenuList>
    </Menu>
  );
};

function ProductsList() {
  const [showLoader, setShowLoader] = useState(true);
  const [query, setQuery] = useState("");
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);

  const [filterItem, setFilterItem] = useState("");
  const [colorItem, setColorItem] = useState("");
  const [brandandSuppliersItem, setBrandandSuppliersItem] = useState("");
  const [brandNameItem, setBrandNameItem] = useState("");
  const [categoriesItem, setCategoriesItem] = useState("");

  const [modal, showModal] = useState(false);
  const [typeToggle, setTypeToggle] = useState(false);
  const [productDelete, setProductDelete] = useState(false);
  const dispatch = useDispatch();
  const [productData, setProductData] = useState([]);

  const fetchProductListData = useSelector(
    (state) => state.user.fetchProductList,
  );

  const fetchProductFilterListRes = useSelector(
    (state) => state.user.fetchProductFilterListRes,
  );

  const [isBuildingBlock, setIsBuildingBlock] = useState(false);

  const getAppSideNavOptions = useSelector(
    (state) => state.user.appSideNavOptions,
  );

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  const screenSize = useScreenSize();
  const deleteProductListData = useSelector(
    (state) => state.user.deleteProductList,
  );

  const [isExpanded, setIsExpanded] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [deleteUser, setDeleteUser] = useState("");

  const open = Boolean(anchorEl);
  const history = useHistory();
  const handleClick = (event, productPartId) => {
    setAnchorEl(event.currentTarget);
    setDeleteUser(productPartId);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  useEffect(() => {
    if (getAppSideNavOptions && getAppSideNavOptions.length > 0) {
      setIsBuildingBlock(
        getAppSideNavOptions.some(
          (x) => x.packageId === process.env.REACT_APP_IS_PREMIUM,
        ),
      );
    }
  }, [getAppSideNavOptions]);

  // for filter list data start.
  const [clearFilter, setClearFilter] = useState(false); // when we clear filter.
  const [productDataList, setProductDataList] = useState([]);

  useEffect(() => {
    const payload = {
      querystring: query,
    };
    dispatch(FetchProductFilterList(payload));
  }, []);

  useEffect(() => {
    if (fetchProductFilterListRes.status && fetchProductFilterListRes?.data) {
      setIsExpanded(false);
      setProductDataList(fetchProductFilterListRes?.data);
    }
  }, [fetchProductFilterListRes]);
  // for filter list data end.

  useEffect(() => {
    // run initially and when we clear filter.
    const payload = {
      pagerequire: perPage,
      pagenumber: currentPage + 1,
      type: filterItem ? filterItem : "",
      querystring: query,
    };
    dispatch(FetchProduct(payload));
    setClearFilter(false);
  }, [clearFilter, query, perPage, currentPage, deleteProductListData]);

  useEffect(() => {
    if (filterItem) {
      const payload = {
        pagerequire: perPage,
        pagenumber: currentPage + 1,
        type: filterItem ? filterItem : "",
        color: "",
        brandSupplier: "",
        category: "",
        querystring: query,
      };
      dispatch(FetchProduct(payload));
      setFilterItem("");
    } else if (colorItem) {
      const payload = {
        pagerequire: perPage,
        pagenumber: currentPage + 1,
        type: "",
        color: colorItem,
        brandSupplier: "",
        category: "",
        querystring: query,
      };
      dispatch(FetchProduct(payload));
      setColorItem("");
    } else if (brandandSuppliersItem) {
      const payload = {
        pagerequire: perPage,
        pagenumber: currentPage + 1,
        type: "",
        color: "",
        brandSupplier: brandandSuppliersItem,
        brandName: "",
        category: "",
        querystring: query,
      };
      dispatch(FetchProduct(payload));
      setBrandandSuppliersItem("");
    } else if (brandNameItem) {
      const payload = {
        pagerequire: perPage,
        pagenumber: currentPage + 1,
        type: "",
        color: "",
        brandSupplier: "",
        brandName: brandNameItem,
        category: "",
        querystring: query,
      };
      dispatch(FetchProduct(payload));
      setBrandNameItem("");
    } else if (categoriesItem) {
      const payload = {
        pagerequire: perPage,
        pagenumber: currentPage + 1,
        type: "",
        color: "",
        brandSupplier: "",
        category: categoriesItem,
        querystring: query,
      };
      dispatch(FetchProduct(payload));
      setCategoriesItem("");
    } else {
      const payload = {
        pagerequire: perPage,
        pagenumber: currentPage + 1,
        type: "",
        color: "",
        brandSupplier: "",
        category: "",
        querystring: query,
      };
      // dispatch(FetchProduct(payload));
    }
  }, [
    currentPage,
    dispatch,
    filterItem !== "",
    colorItem !== "",
    brandandSuppliersItem !== "",
    brandNameItem !== "",
    categoriesItem !== "",
    perPage,
    productDelete,
    query,
  ]);

  useEffect(() => {
    if (fetchProductListData != null) {
      if (fetchProductListData?.status && fetchProductListData?.data) {
        setTotalPages(Math.ceil(fetchProductListData?.totalCount / perPage));
        setShowLoader(false);
        setProductData(fetchProductListData?.data);
      }
    }
  }, [fetchProductListData?.data, perPage]);

  useEffect(() => {
    if (deleteProductListData != null) {
      if (deleteProductListData?.status && deleteProductListData?.data) {
        setProductDelete(!productDelete);
      }
    }
  }, [deleteProductListData?.data]);

  const brandSupplierDisplay = (item) => {
    if (item.type === "Product") {
      if (item.brand && item.suppliername) {
        return item.brand;
      } else {
        return item?.brand ? item?.brand : item?.suppliername;
      }
    } else {
      if (item?.brand && item?.suppliername) {
        return item.brand + "/" + item.suppliername;
      } else if (item?.brand) {
        return item.brand;
      } else {
        return item.suppliername;
      }
    }
  };

  useEffect(() => {
    fetchScreenTranslations("Products And Services").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const [sendDataToAddPurchasing, setSendDataToAddPurchasing] = useState([]);
  const [productPartID, setProductPartID] = useState("");
  const importStatusPollRef = useRef(null);
  const importPollingStateRef = useRef({
    sessionId: 0,
    toastId: null,
    delayMs: 4000,
    snapshot: null,
  });

  const fileInputRef = useRef(null);
  const [excelUploadType, setExcelUploadType] = useState("");

  useEffect(() => {
    return () => {
      if (importStatusPollRef.current) {
        clearTimeout(importStatusPollRef.current);
      }
    };
  }, []);

  const extractImportJobIds = (payload) => {
    const productCandidates = [
      payload?.productImportJobId,
      payload?.productJobId,
      payload?.productResponse?.body?.data?.importJobId,
      payload?.productResponse?.body?.data?.jobId,
      payload?.productResponse?.importJobId,
      payload?.data?.productImportJobId,
    ];
    const supplierCandidates = [
      payload?.supplierImportJobId,
      payload?.supplierJobId,
      payload?.supplierResponse?.body?.data?.importJobId,
      payload?.supplierResponse?.body?.data?.jobId,
      payload?.supplierResponse?.importJobId,
      payload?.data?.supplierImportJobId,
    ];

    const getFirst = (items) =>
      items.find((item) => typeof item === "string" && item.trim() !== "") ||
      "";

    return {
      product: getFirst(productCandidates),
      supplier: getFirst(supplierCandidates),
    };
  };

  const fetchImportJobStatus = async (importJobId) => {
    if (!importJobId) return null;
    const response = await axiosInstance.get(
      `${API_URL}/api/User/ImportJobStatus/${importJobId}`,
    );
    return response?.data?.data || null;
  };

  const startImportStatusPolling = async (jobIds) => {
    if (!jobIds.product && !jobIds.supplier) {
      return;
    }

    if (importStatusPollRef.current) {
      clearTimeout(importStatusPollRef.current);
    }

    const currentSessionId = Date.now();
    importPollingStateRef.current = {
      sessionId: currentSessionId,
      toastId: null,
      delayMs: 4000,
      snapshot: null,
    };

    const scheduleNextPoll = (pollFn, delayMs) => {
      importStatusPollRef.current = setTimeout(pollFn, delayMs);
    };

    const pollStatus = async () => {
      if (importPollingStateRef.current.sessionId !== currentSessionId) {
        return;
      }

      try {
        const [productStatus, supplierStatus] = await Promise.all([
          fetchImportJobStatus(jobIds.product),
          fetchImportJobStatus(jobIds.supplier),
        ]);
        const statusMap = {
          product: productStatus,
          supplier: supplierStatus,
        };
        const nextSnapshot = getImportStatusSnapshot(statusMap);
        const hadMeaningfulChange = hasMeaningfulImportStatusChange(
          importPollingStateRef.current.snapshot,
          nextSnapshot,
        );
        const allTerminal = isAllImportJobsTerminal(statusMap);

        if (
          !importPollingStateRef.current.toastId ||
          hadMeaningfulChange ||
          allTerminal
        ) {
          importPollingStateRef.current.toastId =
            showImportJobStatusNotification(
              statusMap,
              importPollingStateRef.current.toastId,
            );
        }

        importPollingStateRef.current.snapshot = nextSnapshot;
        importPollingStateRef.current.delayMs = getNextPollingDelay(
          importPollingStateRef.current.delayMs,
          hadMeaningfulChange || allTerminal,
        );

        if (allTerminal) {
          if (importStatusPollRef.current) {
            clearTimeout(importStatusPollRef.current);
            importStatusPollRef.current = null;
          }
          return;
        }
        scheduleNextPoll(pollStatus, importPollingStateRef.current.delayMs);
      } catch (error) {
        console.error("Import status polling failed:", error);
        importPollingStateRef.current.delayMs = getNextPollingDelay(
          importPollingStateRef.current.delayMs,
          false,
        );
        scheduleNextPoll(pollStatus, importPollingStateRef.current.delayMs);
      }
    };

    await pollStatus();
  };

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      const formData = new FormData();
      formData.append("file", file);
      // formData.append("excel", file);
      formData.append("productType", excelUploadType);

      // const res = await fetch(
      //   "https://automation.spire.solutions/webhook/product-catalogue",
      //   {
      //     method: "POST",
      //     body: formData,
      //   },
      // );

      const res = await axiosInstance(
        process.env.REACT_APP_PRODUCT_CATALOGUE_API_URL,
        {
          method: "POST",
          data: formData,
        },
      );

      const responseData = res?.data || {};
      const jobIds = extractImportJobIds(responseData);

      if (jobIds.product || jobIds.supplier) {
        await startImportStatusPolling(jobIds);
      } else {
        showProductCatalogueImportNotification(responseData);
      }
    } catch (err) {
      console.error(err);
      // alert("Upload Failed");
    } finally {
      e.target.value = "";
    }
  };

  return (
    <>
      {showLoader && (
        <div
          className="ocr-page-loader bg-transparent"
          style={{ top: "135px", left: "90px" }}
        >
          <Loader />
        </div>
      )}

      <Header
        setQuery={setQuery}
        leftComponent={
          <div className="products-and-parts-header-content">
            <div
              className="products-and-parts-main-title  cursor-pointer"
              onClick={() => {
                history.push("/stock");
              }}
            >
              {/* Stock */}
              {t("Stock")}
            </div>
            <p className="products-and-parts-sub-title products_and_parts_sub_title">
              {/* Products & Parts */}
              {t("Products & Services")}
            </p>
          </div>
        }
      />
      <div
        className={isExpanded ? "pro-part-sidebar-expanded" : ""}
        style={{ paddingLeft: "26.58px" }}
      >
        {screenSize === "xs" ? (
          <div
            style={{
              display: "flex",
              gap: "10px",
              justifyContent: "space-between",
              padding: "20px",
            }}
          >
            <div style={{ display: "flex", gap: "15px" }}>
              <div
                style={{
                  opacity: "60%",
                  color: "#7F7E7F",
                  fontWeight: "bolder",
                  fontSize: "1.1rem",
                  marginTop: "10px",
                  marginBottom: "15px",
                }}
              >
                {/* Stock */}
                {t("Stock")}
              </div>
              <img
                alt=""
                src={Downarrow}
                style={{
                  opacity: "60%",
                  marginTop: "18px",
                  marginBottom: "15px",
                  width: "18px",
                  height: "12px",
                  transform: "rotate(90deg)",
                  cursor: "pointer",
                }}
              />
            </div>
            <div style={{ display: "flex", gap: "15px", marginRight: "20px" }}>
              <img
                alt=""
                src={ProductIcon}
                style={{
                  opacity: "60%",
                  marginTop: "12px",
                  marginBottom: "15px",
                  width: "30px",
                  height: "24px",
                  transform: "rotate(0deg)",
                  cursor: "pointer",
                }}
              />
              <div
                style={{
                  color: "#7F7E7F",
                  fontWeight: "bolder",
                  fontSize: "1.2rem",
                  marginTop: "10px",
                  marginBottom: "15px",
                }}
              >
                {/* Products & Parts */}
                {t("Products & Services")}
              </div>
            </div>
          </div>
        ) : (
          <div className="pro-part-filter-btn">
            <div>
              <ProFilter
                setFilterItem={setFilterItem}
                filterItem={filterItem}
                // productDataList={productDataList}
                productDataList={fetchProductFilterListRes?.data}
                // ASC Recive data from child (ProFilter.js) file below, send from ProFilter file 👇
                setSendColor={setColorItem}
                setSendBrandandSuppliers={setBrandandSuppliersItem}
                setSendBrandName={setBrandNameItem}
                setSendCategories={setCategoriesItem}
                setSendClearFilter={setClearFilter}
              />
            </div>

            <div
              className="nav-link"
              onClick={() => {
                setTypeToggle(true);
                dispatch(EmptyProductPart());
              }}
            >
              <div className="pro-part-add-itm-btn d-flex">
                <Image
                  height={20}
                  width={20}
                  src={packageIcn}
                  className="pro-part-add-itm-btn-icn"
                />
                <Image
                  height={20}
                  width={20}
                  src={actfilter}
                  className="pro-part-add-itm-btn-hover-icn"
                />
                <div className="pro-part-add-itm-btn-text">
                  {/* Add item */}
                  {t("Add item")}
                </div>
              </div>
            </div>

            {typeToggle && (
              <div className="stock-level-cards">
                <div className="modal-title-wrp">
                  <span>
                    {/* Choose the type of item */}
                    {t("Choose the type of item")}
                  </span>
                  <img
                    src={xIcon}
                    alt=""
                    onClick={() => setTypeToggle(false)}
                    style={{ cursor: "pointer", padding: "0px 16px " }}
                  />
                </div>

                {/* Hidden File Input */}
                <input
                  type="file"
                  accept=".xlsx,.xls"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />

                <div className="stock-level-cards-sub">
                  <Link
                    className="stock-level-cards-card redirect-link"
                    to={{
                      pathname: `/add-product`,
                      state: {
                        productType: 0,
                      },
                    }}
                  >
                    <div className="stock-level-cards-card-content">
                      <img src={Package} alt="" />
                      <span className="ps-4">
                        {/* Compose Product */}
                        {t("Compose Product")}
                      </span>

                      <div
                        className="ms-auto d-none"
                        title="Import"
                        style={{ transform: "rotate(180deg)" }}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          fileInputRef.current.click();
                          setExcelUploadType("product");
                        }}
                      >
                        <img
                          src={importIcon}
                          alt=""
                          style={{ width: "14px" }}
                        />
                      </div>

                      <div
                        className="px-1 d-none"
                        title="Export"
                        onClick={(e) => {
                          e.preventDefault();
                          // asc
                        }}
                      >
                        <img
                          src={importIcon}
                          alt=""
                          style={{ width: "14px" }}
                        />
                      </div>
                    </div>
                  </Link>

                  <Link
                    className="stock-level-cards-card redirect-link"
                    to={{
                      pathname: `/add-part`,
                      state: {
                        productType: 1,
                      },
                    }}
                  >
                    <div className="stock-level-cards-card-content">
                      <img src={addPart} alt="" />
                      <span className="ps-4">
                        {/* Add Part */}
                        {t("Add Part")}
                      </span>

                      <div
                        className="ms-auto"
                        title="Import"
                        style={{ transform: "rotate(180deg)" }}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          fileInputRef.current.click();
                          setExcelUploadType("Part");
                        }}
                      >
                        <img
                          src={importIcon}
                          alt=""
                          style={{ width: "14px" }}
                        />
                      </div>

                      <div
                        className="px-1 d-none"
                        title="Export"
                        onClick={(e) => {
                          e.preventDefault();
                          // asc
                        }}
                      >
                        <img
                          src={importIcon}
                          alt=""
                          style={{ width: "14px" }}
                        />
                      </div>
                    </div>
                  </Link>

                  <Link
                    className="stock-level-cards-card redirect-link"
                    to={{
                      pathname: `/add-service`,
                      state: {
                        productType: 2,
                      },
                    }}
                  >
                    <div className="stock-level-cards-card-content">
                      <img src={Setting} alt="" />
                      <span className="ps-4">
                        {/* Add Services */}
                        {t("Add Services")}
                      </span>

                      <div
                        className="ms-auto d-none"
                        title="Import"
                        style={{ transform: "rotate(180deg)" }}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          fileInputRef.current.click();
                          setExcelUploadType("Services");
                        }}
                      >
                        <img
                          src={importIcon}
                          alt=""
                          style={{ width: "14px" }}
                        />
                      </div>

                      <div
                        className="px-1 d-none"
                        title="Export"
                        onClick={(e) => {
                          e.preventDefault();
                          // asc
                        }}
                      >
                        <img
                          src={importIcon}
                          alt=""
                          style={{ width: "14px" }}
                        />
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            )}
          </div>
        )}

        {screenSize === "xs" && (
          <div
            style={{
              marginTop: "20px",
              marginLeft: "20px",
              marginRight: "20px",
            }}
          >
            <div className="choose-project-dropdown">
              <div
                className="project-drop-view d-flex"
                style={{
                  justifyContent:
                    screenSize === "xs" ? "flex-start" : "space-between",
                }}
              >
                {screenSize === "xs" && (
                  <img className="search_pop ms-2 mb-1" src={searchIcon} />
                )}
                <p
                  className="margin-0-pop  ps-2"
                  // onClick={() => setShowClientDrop(!showClientDrop)}
                >
                  {screenSize === "xs" ? "Search" : "Type a project "}
                </p>
                {screenSize !== "xs" && (
                  <BsChevronDown
                    size={18}
                    // onClick={() => setShowClientDrop(!showClientDrop)}
                    className={"down-arrow-pop bi-paperclip ms-4 ms-xxl-3"}
                  />
                )}
              </div>
            </div>
          </div>
        )}
        <div
          className={
            screenSize === "xs"
              ? "table-container-pro-part-mobile"
              : "table-container-pro-part table-container-pro-part_lap"
          }
          // style={{ width : "1100px"}}
        >
          <table className={screenSize === "xs" ? "table-padding-mobile" : ""}>
            {screenSize === "xs" ? (
              <thead>
                <tr className="pro-part-row pro-part-row-data">
                  <th style={{ width: "12%", fontWeight: "400" }}>
                    {/* Item ID */}
                    {t("Item Id")}
                  </th>
                  <th style={{ width: "31%", fontWeight: "400" }} className="">
                    Description
                  </th>
                </tr>
              </thead>
            ) : (
              <thead>
                <tr className="pro-part-row pro-part-row-head">
                  <th style={{ width: "31%", fontWeight: "400" }} className="">
                    {/* Item Description */}
                    {t("Item Description")}
                  </th>
                  <th style={{ width: "12%", fontWeight: "400" }}>
                    {/* Item Id */}
                    {t("Item Id")}
                  </th>
                  <th style={{ width: "15%", fontWeight: "400" }}>
                    {/* Brand/Supplier */}
                    {t("Brand/Suppliers")}
                  </th>
                  <th style={{ width: "12%", fontWeight: "400" }}>
                    {/* Colors */}
                    {t("Colors")}
                  </th>
                  <th style={{ width: "15%", fontWeight: "400" }}>
                    {/* Categories */}
                    {t("Categories")}
                  </th>
                  <th
                    style={{ width: "5%", fontWeight: "400" }}
                    className="text-center"
                  >
                    {/* Stock */}
                    {t("Stock")}
                  </th>
                  <th
                    style={{ width: "10%", fontWeight: "400" }}
                    className="text-end"
                  ></th>
                </tr>
              </thead>
            )}
            <tbody>
              {productData?.length > 0 &&
                productData?.map((item, index) => {
                  if (screenSize === "xs") {
                    return (
                      <tr
                        key={`tbl-row-${index}`}
                        className="pro-part-row pro-part-row-data"
                      >
                        <td>{item.productPartCode}</td>
                        <td className="title-hover">
                          <Link
                            className="redirect-link"
                            to={{
                              // in mobile view
                              pathname:
                                item.type === "Product"
                                  ? `/update-product/${item.productPartid}`
                                  : item.type === "Part"
                                    ? `/update-part/${item.productPartid}`
                                    : `/update-service/${item.productPartid}`,
                              state: {
                                productPartId: item.productPartid,
                                productPartCode: item.productPartCode,
                              },
                            }}
                          >
                            <div>{item.itemdescription}</div>
                          </Link>
                        </td>

                        <td
                          className={
                            screenSize === "xs" ? "text-end" : "text-end pe-3"
                          }
                        >
                          <div>
                            <FiMoreVertical
                              color="323232"
                              fontSize="1.4rem"
                              id="basic-button"
                              onClick={(e) => {
                                handleClick(e, item.productPartid);
                                const productListData = {
                                  pathname: "/add-purchasing-order",
                                  state: {
                                    from: "ProductList_Screen",
                                    historyPartName: item.partName,
                                    historyProductPartid: item.productPartid,
                                    historySuppliername: item.suppliername,
                                    historySupplierid: item.supplierid,
                                  },
                                };
                                setSendDataToAddPurchasing(productListData);
                              }}
                              cursor="pointer"
                            />
                            <MoreActionMenu
                              anchorEl={anchorEl}
                              open={open}
                              handleClose={handleClose}
                              showModal={showModal}
                              reciveDataToAddPurchasing={
                                sendDataToAddPurchasing
                              }
                            />
                          </div>
                        </td>
                      </tr>
                    );
                  }
                  return (
                    <tr
                      key={`tbl-row-${index}`}
                      className="pro-part-row pro-part-row-data"
                    >
                      <td className="title-hover">
                        <div className="items-desc-column">
                          {isBuildingBlock && (
                            <div className="desc-image-wrp desc-image ">
                              {item.coverimage ? (
                                <>
                                  <div
                                    className={`product-list-image-default ${
                                      item.image.length === 0
                                        ? "hover-hide"
                                        : ""
                                    }`}
                                  >
                                    <img
                                      src={item.coverimage}
                                      alt=""
                                      className="cover-image object-fit-contain"
                                    />
                                    {item.image && item.image.length > 0 && (
                                      <div className="image-row">
                                        {item.image
                                          .slice(0, 3)
                                          .map((val, index) => (
                                            <img
                                              key={index}
                                              src={val.image}
                                              alt={`Images ${index + 1}`}
                                            />
                                          ))}
                                      </div>
                                    )}
                                  </div>
                                  {item.image && item.image.length > 0 && (
                                    <span className="desc-image-plus">
                                      <Image
                                        height={10}
                                        width={10}
                                        src={plusBorderWhite}
                                      />
                                    </span>
                                  )}
                                </>
                              ) : (
                                <div className="product-list-default">
                                  <img
                                    src={
                                      item?.type === "Part"
                                        ? addPart
                                        : item?.type === "Product"
                                          ? Package
                                          : item?.type === "Service"
                                            ? Setting
                                            : ""
                                    }
                                    alt=""
                                    className="default-img"
                                  />
                                  <div className="product-image-title">
                                    {/* Picture */}
                                    {t("Picture ")}
                                  </div>
                                </div>
                              )}
                            </div>
                          )}
                          <Link
                            className="redirect-link"
                            to={{
                              pathname:
                                item.type === "Product"
                                  ? `/update-product/${item.productPartid}`
                                  : item.type === "Part"
                                    ? `/update-part/${item.productPartid}`
                                    : `/update-service/${item.productPartid}`,
                              state: {
                                productPartId: item.productPartid,
                                productPartCode: item.productPartCode,
                                productType:
                                  item.type === "Product"
                                    ? 0
                                    : item.type === "Part"
                                      ? 1
                                      : 2,
                              },
                            }}
                          >
                            <div>
                              {item.partName.length > 35
                                ? `${item.partName.slice(0, 35)}...`
                                : item.partName}
                            </div>
                          </Link>
                        </div>
                      </td>

                      {/* <td>{item.productPartCode}</td> */}
                      <td>{item.itemid}</td>

                      <td className="pro-part-more-con">
                        {brandSupplierDisplay(item)}
                        {item.suppliercount > 1 && (
                          <span className="pro-part-more-brand">
                            <span className="pro-part-more-brand-text">
                              +{item.suppliercount - 1}
                            </span>
                          </span>
                        )}
                      </td>
                      <td>
                        <ColorTag tagList={item.colorcode}></ColorTag>
                      </td>
                      <td>
                        {/* <div>{item.productpartcategories.slice(0, 1).map((x)=>x.categories)}</div> */}
                        {item.productpartcategories.length === 1 ? (
                          <div>{`${item.productpartcategories
                            .slice(0, 1)
                            .map((x) => x.categories)}`}</div>
                        ) : (
                          <div>{item.categories}</div>
                        )}

                        {item.productpartcategories.length > 1 && (
                          <div>{`${item.productpartcategories
                            .slice(0, 1)
                            .map((x) => x.categories)} + 
                          ${item.productpartcategories.length - 1}`}</div>
                        )}
                      </td>
                      <td className="text-center">
                        {/* <Tooltip
                      title={
                        <div className="d-flex flex-column" style={{ gap: "5px" }}>
                          <div
                            className="d-flex justify-content-center align-items-center"
                            style={{ gap: "8px" }}
                          >
                            <div
                              className="pro-part-col-stock-tag"
                              style={{ background: "red" }}
                            ></div>
                            <div className="stock-tooltip-label">6</div>
                          </div>
                          <div
                            className="d-flex justify-content-center align-items-center"
                            style={{ gap: "8px" }}
                          >
                            <div
                              className="pro-part-col-stock-tag"
                              style={{ background: "green" }}
                            ></div>
                            <div className="stock-tooltip-label">7</div>
                          </div>
                          <div
                            className="d-flex justify-content-center align-items-center"
                            style={{ gap: "8px" }}
                          >
                            <div
                              className="pro-part-col-stock-tag"
                              style={{ background: "yellow" }}
                            ></div>
                            <div className="stock-tooltip-label">9</div>
                          </div>
                        </div>
                      }
                      placement="right"
                      componentsProps={{
                        tooltip: {
                          sx: {
                            bgcolor: "transparent",
                            paddingLeft: "25px",
                          },
                        },
                      }}
                    >
                      <span className="stock-tooltip-leb">{item?.stock ? item.stock :'-'}</span>
                    </Tooltip> */}
                        <div>
                          {item?.stock > 0 && item?.isLowStock && (
                            <MakePurchaseTooltip
                              classes="ms-2 mb-4 me-1"
                              brandName={item?.brand}
                              brandId={item?.brandId}
                            />
                          )}

                          {item?.stock ? item.stock : "-"}
                        </div>
                      </td>
                      <td className="text-end pe-3">
                        <div>
                          <FiMoreVertical
                            color="323232"
                            fontSize="1.4rem"
                            id="basic-button"
                            // aria-controls={open ? 'basic-menu' : undefined}
                            // aria-haspopup="true"
                            // aria-expanded={open ? 'true' : undefined}
                            onClick={(e) => {
                              handleClick(e, item.productPartid);
                              const productListData = {
                                pathname: "/add-purchasing-order",
                                state: {
                                  from: "ProductList_Screen",
                                  historyPartName: item.partName,
                                  historyProductPartid: item.productPartid,
                                  historySuppliername: item.suppliername,
                                  historySupplierid: item.supplierid,
                                },
                              };
                              setSendDataToAddPurchasing(productListData);
                              setProductPartID(item.productPartid);
                            }}
                            cursor="pointer"
                          />
                          <MoreActionMenu
                            anchorEl={anchorEl}
                            open={open && productPartID === item.productPartid}
                            handleClose={handleClose}
                            showModal={showModal}
                            reciveDataToAddPurchasing={sendDataToAddPurchasing}
                          />
                        </div>
                      </td>
                    </tr>
                  );
                })}
              {!productData?.filter(
                (items) =>
                  items?.itemdescription?.toLowerCase()?.includes(query) ||
                  items?.productPartCode?.toLowerCase()?.includes(query) ||
                  items?.suppliername?.toLowerCase()?.includes(query) ||
                  items?.brand?.toLowerCase()?.includes(query) ||
                  items?.categories?.toLowerCase()?.includes(query) ||
                  items?.stock?.toString().toLowerCase()?.includes(query),
              ).length > 0 && (
                <tr style={{ height: "83%" }}>
                  <td
                    className="row container mt-5 pt-5 d-flex position-relative"
                    style={{ left: "100%" }}
                  >
                    <img
                      src={smaliIcon}
                      alt="smali"
                      width={35}
                      height={35}
                      className="mt-5 "
                    />
                    <h6
                      className="mt-1"
                      style={{
                        fontSize: "14px",
                        fontWeight: 400,
                        textAlign: "center",
                        color: "#707070",
                      }}
                    >
                      {/* Sorry. */}
                      {t("Sorry.")}
                      <br />
                      {/* No results for your criteria. */}
                      {t("No results for your criteria.")}
                      <br />
                      {/* Try to refine your search or enter a new search. */}
                      {t("Try to refine your search or enter a new search.")}
                    </h6>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {screenSize === "xs" ? (
          <div
            style={{
              position: "fixed",
              bottom: "0",
              paddingBottom: "15px",
              width: "100%",
              background: "#fafafa",
              paddingLeft: "20px",
            }}
          >
            <section
              style={{
                width: "90%",
                display: "flex",
                justifyContent: "space-between",
                marginTop: "10px",
                marginBottom: "25px",
              }}
            >
              <div style={{ display: "flex", gap: "10px" }}>
                <img
                  alt=""
                  src={Downarrow}
                  // onClick={() => paginationMobile()}
                  style={{
                    marginTop: "3px",
                    width: "18px",
                    height: "12px",
                    transform: "rotate(90deg)",
                    cursor: "pointer",
                    opacity: currentPage === 0 ? "50%" : "100%",
                    pointerEvents: currentPage === 0 ? "none" : "all",
                  }}
                />
                <p className="previous-week-text">Present Page</p>
              </div>
              <div style={{ display: "flex", gap: "10px" }}>
                <p className="present-week-text">Next Page</p>
                <img
                  alt=""
                  src={Downarrow}
                  // onClick={() => paginationMobile("next")}
                  style={{
                    width: "18px",
                    marginTop: "3px",
                    height: "12px",
                    transform: "rotate(-90deg)",
                    cursor: "pointer",
                    opacity: currentPage === totalPages - 1 ? "50%" : "100%",
                    pointerEvents:
                      currentPage === totalPages - 1 ? "none" : "all",
                  }}
                />
              </div>
            </section>
            <div style={{ width: "90%" }}>
              <Link
                to="/add-part"
                className="nav-link"
                onClick={() => {
                  setTypeToggle(true);
                  dispatch(EmptyProductPart());
                }}
              >
                <button
                  style={{ width: "100%" }}
                  className="worktime-add-btn frc"
                >
                  {/* <p>Add Item</p> */}
                  <p>{t("Add item")}</p>
                </button>
              </Link>
            </div>
          </div>
        ) : (
          <div className="align-text-bottom stock-pagination">
            <Pagination
              perPage={perPage}
              setPerPage={setPerPage}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              totalPages={totalPages}
            />
          </div>
        )}

        <Modal
          show={modal}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          id="member-error-modal"
          className="modal_start"
        >
          <Modal.Body>
            <p
              style={{
                textAlign: "center",
                marginTop: "3rem",
              }}
              className="responsive-margin-bottom"
            >
              {deleteUser && (
                <span
                  style={{
                    color: "#FC685A",
                    fontSize: "clamp(14px, 0.833vw, 0.833vw)",
                    fontWeight: "700",
                    display: "inline-block",
                  }}
                  className="responsive-margin-2"
                >
                  This data will be removed from the system
                  <br /> and cannot be undone.
                </span>
              )}
              <p
                style={{
                  marginTop: "0.5rem",
                  fontSize: "clamp(14px, 0.833vw, 0.833vw)",
                  fontWeight: "bold",
                  color: "#333333",
                }}
              >
                {/* Do you want to proceed? */}
                {t("Do you want to proceed?")}
              </p>
            </p>
            <Row
              style={{
                // width: "80%",
                width: "max-content",
                margin: "4rem auto 4rem auto",
                textAlign: "center",
              }}
            >
              <Col style={{ textAlign: "center" }}>
                <button
                  className="cancel-btn"
                  style={{
                    justifySelf: "center",
                    backgroundColor: "transparent",
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    showModal(false);
                    setDeleteUser("");
                  }}
                >
                  {/* No */}
                  {t("No")}
                </button>
              </Col>
              <Col>
                <button
                  className="cancel-btn invite-btn"
                  style={{
                    backgroundColor: `#F76767`,
                    borderColor: `#F76767`,
                    color: "#FFFFFF",
                  }}
                  onClick={() => {
                    deleteUser && dispatch(DeleteProduct(deleteUser));
                    showModal(false);
                  }}
                >
                  {/* Yes */}
                  {t("Yes")}
                </button>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}

export default ProductsList;
